import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import OteConTypes from "./OteConTypes/OteConTypes";
import OteFpas from "./OteFpa/OteFpas";
import OtellConTypes from "./OtellConTypes/OtellConTypes";


const Billings = () =>{

    const chipHeaders = ["Είδη τηλεπ. γραμμών ΟΤΕ", "Είδη γραμμών ΟΤΕ", "Κατηγορίες ΦΠΑ"];
    const chipItems: React.ReactNode[] = [
      <OtellConTypes/>,
      <OteConTypes />,
      <OteFpas />,
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default Billings